import type { Room } from '@hollowveil/shared';

export const roomHawkinsSuburb: Room = {
  id: 'room_hawkins_suburb',
  name: "Hawkins - Banlieue",
  description: "Une rue tranquille de banlieue américaine des années 80. Quelque chose d'étrange se passe ici...",
  size: [24, 10, 24],
  floorStyle: 'stone',
  ambiance: {
    realWorld: {
      backgroundColor: '#87CEEB',
      ambientLightColor: '#FFF8DC',
      ambientLightIntensity: 0.8,
    },
    spectralWorld: {
      backgroundColor: '#0a0a12',
      ambientLightColor: '#1a3a5c',
      ambientLightIntensity: 0.15,
      fogColor: '#0d1a2d',
      fogDensity: 0.08,
    },
  },
  objects: [
    // ===== MONDE RÉEL - OBJETS ANNÉES 80 =====

    // Vélo vintage
    {
      id: 'obj_bike_1',
      name: 'Vélo BMX',
      type: 'interactive',
      modelId: 'vintage_bike',
      position: [4, 0, 8],
      rotation: [0, 0.3, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { color: 'red' },
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Un vélo BMX rouge. Il appartient probablement à un des enfants du quartier.",
          },
        },
      ],
    },

    // Walkie-Talkie
    {
      id: 'obj_walkie_talkie',
      name: 'Walkie-Talkie',
      type: 'interactive',
      modelId: 'walkie_talkie',
      position: [10, 0.5, 10],
      rotation: [0, 0, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'walkie_talkie',
            itemName: 'Walkie-Talkie',
            itemDescription: "Un talkie-walkie Realistic TRC-214. On entend des grésillements étranges...",
            itemIcon: 'scroll',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "*KRRR* ...aide... *KRRR* ...l'Upside Down... *KRRR*",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_walkie_talkie' },
        },
      ],
    },

    // Lampe de poche
    {
      id: 'obj_flashlight',
      name: 'Lampe de Poche',
      type: 'interactive',
      modelId: 'flashlight',
      position: [18, 0.3, 5],
      rotation: [0, 0.8, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'flashlight',
            itemName: 'Lampe de Poche',
            itemDescription: "Une lampe de poche Maglite. Essentielle pour explorer l'obscurité.",
            itemIcon: 'orb',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Tu récupères la lampe de poche. Elle pourrait être utile dans l'autre monde...",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_flashlight' },
        },
      ],
    },

    // Boîte à lettres
    {
      id: 'obj_mailbox_1',
      name: 'Boîte aux Lettres',
      type: 'static',
      modelId: 'mailbox',
      position: [2, 0, 6],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // Voiture années 80
    {
      id: 'obj_car_80s',
      name: 'Ford Pinto',
      type: 'static',
      modelId: 'car_80s',
      position: [3, 0, 16],
      rotation: [0, Math.PI / 2, 0],
      scale: [1.3, 1.3, 1.3],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { color: 'brown' },
    },
    // Version cassée dans l'Upside Down
    {
      id: 'obj_car_wrecked_1',
      name: 'Épave de Voiture',
      type: 'static',
      modelId: 'car_wrecked',
      position: [3, 0, 16],
      rotation: [0, Math.PI / 2 + 0.2, 0],
      scale: [1.3, 1.3, 1.3],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Lampadaires
    {
      id: 'obj_streetlamp_1',
      name: 'Lampadaire',
      type: 'static',
      modelId: 'streetlamp',
      position: [1, 0, 10],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },
    {
      id: 'obj_streetlamp_2',
      name: 'Lampadaire',
      type: 'static',
      modelId: 'streetlamp',
      position: [22, 0, 10],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },

    // === ROUTE ===
    {
      id: 'obj_road_1',
      name: 'Route',
      type: 'static',
      modelId: 'road_segment',
      position: [12, 0, 12],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: { length: 26, width: 4 },
    },

    // === BUS SCOLAIRE ===
    {
      id: 'obj_school_bus',
      name: 'Bus Scolaire Abandonné',
      type: 'interactive',
      modelId: 'school_bus',
      position: [12, 0, 12],
      rotation: [0, 0.1, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Un bus scolaire du district de Hawkins. Il semble avoir été abandonné en urgence...",
          },
        },
      ],
    },

    // === PYLONES ÉLECTRIQUES ===
    {
      id: 'obj_pylon_1',
      name: 'Pylône Électrique',
      type: 'static',
      modelId: 'electric_pylon',
      position: [6, 0, 22],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },
    {
      id: 'obj_pylon_2',
      name: 'Pylône Électrique',
      type: 'static',
      modelId: 'electric_pylon',
      position: [18, 0, 22],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },
    // Câble entre pylônes
    {
      id: 'obj_power_line_1',
      name: 'Ligne Électrique',
      type: 'static',
      modelId: 'power_line',
      position: [12, 5, 22],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: { length: 12, sag: 0.8 },
    },

    // Arbre
    {
      id: 'obj_tree_suburb_1',
      name: 'Chêne',
      type: 'static',
      modelId: 'tree',
      position: [8, 0, 2],
      rotation: [0, 0.5, 0],
      scale: [1.2, 1.4, 1.2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // === MAISONS (3 au lieu de 7) ===
    {
      id: 'obj_house_1',
      name: 'Maison Wheeler',
      type: 'static',
      modelId: 'suburban_house',
      position: [5, 0, 3],
      rotation: [0, 0, 0],
      scale: [2.5, 2, 1.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { variant: 'blue' },
    },
    {
      id: 'obj_house_2',
      name: 'Maison Byers',
      type: 'interactive',
      modelId: 'suburban_house',
      position: [14, 0, 3],
      rotation: [0, 0, 0],
      scale: [2.2, 1.8, 1.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { variant: 'brown' },
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La maison des Byers. Des guirlandes de Noël sont accrochées partout...",
          },
        },
      ],
    },
    {
      id: 'obj_house_3',
      name: 'Maison Creel',
      type: 'interactive',
      modelId: 'suburban_house',
      position: [19, 0, 20],
      rotation: [0, Math.PI, 0],
      scale: [3, 2.5, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { variant: 'dark' },
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La maison Creel... Abandonnée depuis des années. On dit qu'elle est hantée...",
          },
        },
      ],
    },

    // === MAISONS ABÎMÉES UPSIDE DOWN ===
    {
      id: 'obj_house_ruined_1',
      name: 'Ruines Wheeler',
      type: 'static',
      modelId: 'suburban_house',
      position: [5, 0, 3],
      rotation: [0.05, 0.1, 0],
      scale: [2.5, 1.8, 1.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: { variant: 'ruined' },
    },
    {
      id: 'obj_house_ruined_2',
      name: 'Ruines Byers',
      type: 'static',
      modelId: 'suburban_house',
      position: [14, 0, 3],
      rotation: [-0.03, -0.08, 0.02],
      scale: [2.2, 1.5, 1.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: { variant: 'ruined' },
    },
    {
      id: 'obj_house_ruined_3',
      name: 'Ruines Creel',
      type: 'interactive',
      modelId: 'suburban_house',
      position: [19, 0, 20],
      rotation: [0.08, Math.PI + 0.15, -0.05],
      scale: [3, 2, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: { variant: 'ruined' },
    },

    // Christmas lights
    {
      id: 'obj_christmas_lights',
      name: 'Guirlandes Lumineuses',
      type: 'interactive',
      modelId: 'christmas_lights',
      position: [14, 1.5, 2],
      rotation: [0, 0, 0],
      scale: [1.5, 1, 1],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Les lumières clignotent... R-U-N ?",
          },
        },
      ],
    },

    // ===== UPSIDE DOWN =====

    // Arbres morts
    {
      id: 'obj_dead_tree_1',
      name: 'Arbre Mort',
      type: 'static',
      modelId: 'dead_tree',
      position: [8, 0, 2],
      rotation: [0, 0.5, 0],
      scale: [1.3, 1.5, 1.3],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_dead_tree_2',
      name: 'Arbre Corrompu',
      type: 'static',
      modelId: 'dead_tree',
      position: [4, 0, 18],
      rotation: [0, 2.5, 0],
      scale: [1.2, 1.4, 1.2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Lianes
    {
      id: 'obj_vine_1',
      name: 'Lianes Organiques',
      type: 'static',
      modelId: 'upside_down_vines',
      position: [5, 0, 10],
      rotation: [0, 0, 0],
      scale: [1.2, 1.5, 1.2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Portail
    {
      id: 'obj_gate',
      name: 'La Faille',
      type: 'interactive',
      modelId: 'upside_down_gate',
      position: [12, 0, 18],
      rotation: [0, 0, 0],
      scale: [1.5, 2, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Une faille dimensionnelle... Le Voile entre les mondes est déchiré ici.",
          },
        },
      ],
    },

    // Membrane organique
    {
      id: 'obj_membrane_1',
      name: 'Membrane Organique',
      type: 'static',
      modelId: 'organic_membrane',
      position: [10, 0.01, 15],
      rotation: [0, 0, 0],
      scale: [3, 1, 3],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Eggo
    {
      id: 'obj_eggo',
      name: 'Boîte d\'Eggo',
      type: 'interactive',
      modelId: 'eggo_box',
      position: [16, 0.2, 8],
      rotation: [0, 0.3, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'eggo',
            itemName: 'Gaufres Eggo',
            itemDescription: "Des gaufres Eggo. Quelqu'un les adore vraiment...",
            itemIcon: 'star',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Des gaufres Eggo ! Elles semblent importantes pour quelqu'un...",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_eggo' },
        },
      ],
    },
  ],
  puzzles: [
    {
      id: 'puzzle_find_gate',
      name: 'Trouver la Faille',
      type: 'worldBridge',
      state: 'active',
      description: 'Explore les deux mondes pour comprendre ce qui se passe à Hawkins.',
      hint: 'Utilise le walkie-talkie pour capter des signaux de l\'autre côté...',
      linkedObjectIds: ['obj_gate', 'obj_walkie_talkie'],
      solution: {
        type: 'items',
        expected: ['walkie_talkie', 'flashlight'],
      },
      onSolve: [
        {
          type: 'showMessage',
          params: {
            message: 'Tu as rassemblé ce qu\'il faut pour explorer l\'Upside Down en sécurité !',
          },
        },
      ],
    },
  ],
  connections: [
    {
      targetRoomId: 'room_upside_down_lab',
      position: [12, 0, 20],
      direction: 'north',
      locked: false,
    },
  ],
  initialWorld: 'real',
  hasSpectralLayer: true,
  palette: 'night',
  biome: 'upside_down',
  weather: 'spores',
  weatherIntensity: 0.6,
  npcs: [
    // === MONDE RÉEL ===
    {
      id: 'npc_dog_dustin',
      type: 'fox',
      name: 'Dart Junior',
      position: [15, 0, 8],
      scale: 2,
      idleAnimation: 'sit',
      petAnimation: 'nuzzle',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'real',
    },

    // === UPSIDE DOWN - MONSTRES (réduits) ===
    {
      id: 'npc_demodog_1',
      type: 'demodog',
      name: 'Demodog Alpha',
      position: [8, 0, 16],
      scale: 3,
      idleAnimation: 'prowl',
      petAnimation: 'growl',
      petRadius: 3,
      petCooldown: 5000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_demodog_2',
      type: 'demodog',
      name: 'Demodog',
      position: [18, 0, 14],
      scale: 2.5,
      idleAnimation: 'prowl',
      petAnimation: 'growl',
      petRadius: 3,
      petCooldown: 5000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    // Demogorgon
    {
      id: 'npc_demogorgon',
      type: 'demogorgon',
      name: 'Le Demogorgon',
      position: [20, 0, 20],
      rotation: [0, -Math.PI * 0.75, 0],
      scale: 4,
      idleAnimation: 'idle',
      petAnimation: 'roar',
      petRadius: 4,
      petCooldown: 10000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    // Mind Flayer (plus petit)
    {
      id: 'npc_mind_flayer',
      type: 'mind_flayer',
      name: 'Le Flagelleur Mental',
      position: [12, 0, 12],
      scale: 5,
      idleAnimation: 'idle',
      petAnimation: 'roar',
      petRadius: 6,
      petCooldown: 15000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
  ],
};
